import { useSelector } from 'react-redux';

import { ORDER_STATUS } from '~constants/orders';

export function useIsTakeOrderScreen() {
  const activeTab = useSelector((state) => state.order.activeTab);

  const isTakeOrderManagerScreen = activeTab?.toLowerCase() === ORDER_STATUS.ORDER_TAKER;

  return isTakeOrderManagerScreen;
}
